export default "__VITE_ASSET__BWwcoL8R__"